
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class TicketHelper extends Vue {
    public ticketPriorities: any = [
        { title: this.$t('tickets.priority-low', 'Low'), id: 0 },
        { title: this.$t('tickets.priority-standard', 'Standard'), id: 1 },
        { title: this.$t('tickets.priority-high', 'High'), id: 2 },
        { title: this.$t('tickets.priority-critical', 'Critical'), id: 3 },
    ];

    public getVisibleState(state: string) {
        switch (state) {
            case 'new':
                return this.$t('tickets.status-pending', 'Pending');
                break;
            case 'open':
                return this.$t('tickets.status-in-progress', 'In-Progress');
                break;
            case 'closed':
                return this.$t('tickets.status-cancelled', 'Cancelled');
                break;
            default:
                return this.$t('tickets.status-completed', 'Completed');
                break;
        }
    }

    public getVisibleStateClass(state: string) {
        switch (state) {
            case 'new':
                return 'default-state';
                break;
            case 'open':
                return 'primary-state';
                break;
            case 'resolved':
                return 'secondary-state';
                break;
            default:
                return 'danger-state';
                break;
        }
    }

    public priorityBadgeClass(priorityId: number) {
        switch (priorityId) {
            case 1:
                return 'badge-yellow';
                break;
            case 2:
                return 'badge-orange';
                break;
            case 3:
                return 'badge-red';
                break;
            default:
                return 'badge-purple';
                break;
        }
    }

    public ticketPriorityIconClass(priorityId: number) {
        switch (priorityId) {
            case 1:
                return 'ticket-item-body-priority-high';
                break;
            case 2:
                return 'ticket-item-body-priority-urgent';
                break;
            case 3:
                return 'ticket-item-body-priority-critical';
                break;
            default:
                return 'ticket-item-body-priority-standard';
                break;
        }
    }

    public ticketPriorityTextById(priorityId: number) {
        switch (priorityId) {
            case 1:
                return this.$t('tickets.priority-standard', 'Standard');
                break;
            case 2:
                return this.$t('tickets.priority-high', 'High');
                break;
            case 3:
                return this.$t('tickets.priority-critical', 'Critical');
                break;
            default:
                return this.$t('tickets.priority-low', 'Low');
                break;
        }
    }

    public returnSubjectType(type: string) {
        if (type === 'questions') {
            return 'ticket-item-question';
        } else if (type === 'feedback') {
            return 'ticket-item-feedback';
        } else {
            return 'ticket-item-defect';
        }
    }

    public returnIconClass(type: string) {
        if (type === 'questions') {
            return 'fal fa-question-circle';
        } else if (type === 'feedback') {
            return 'fal fa-megaphone';
        } else {
            return 'fal fa-toolbox';
        }
    }
}
